import { ActivateLicense } from "../../../../core/api";
import style from "./Modal.module.scss";
import { dateToRu } from "@/services/date.service";
import { Button, Popup } from "@aurora/components";
import cx from "classnames";
import { FC } from "react";

interface ILicenseDetailProps {
  clickOnClose: any;
  licenseData: ActivateLicense | undefined;
}

const LicenseDetail: FC<ILicenseDetailProps> = ({
  clickOnClose,
  licenseData,
}) => {
  const tarifPlan = "Энтерпрайз";

  return (
    <>
      <Popup
        classNameContent={cx(style.modal, "p-16")}
        classNameWrapper="p-0"
        onClickCloseCross={clickOnClose}
        onClickOutside={clickOnClose}
      >
        <div className={"title-and-buttons-align"}>
          <h1 className={cx("my-0 text-black")}>О программе</h1>
          <div>
            <Button onClick={clickOnClose} variant="secondary">
              Закрыть
            </Button>
          </div>
        </div>
        <p>Наименование ПО: Carrot</p>
        <p>Версия ПО: {__APP_VERSION__}</p>
        <p>Тарифный план: {tarifPlan}</p>
        <p>ID лицензии: {licenseData?.serialNumber}</p>
        <p>
          Срок действия: {licenseData ? dateToRu(licenseData.validTo) : "-"}
        </p>
        <p>Лицензиат: {licenseData?.clientName}</p>
        <p>ИНН: 7730304734</p>
        <p>ОГРН: 1237700323475</p>
        <p>
          Сайт:{" "}
          <a
            href="https://fork-tech.ru/carrot"
            rel="noreferrer"
            target="_blank"
          >
            https://fork-tech.ru/carrot
          </a>
        </p>
        <p>
          <a href={"#"}>Политика конфиденциальности</a>
        </p>
        <p>© {new Date().getFullYear()} ООО «ФОРКТЕК». Все права защищены.</p>
      </Popup>
    </>
  );
};

export default LicenseDetail;
